<form [formGroup]="form">
  <span class="section-title">{{ "shared.media" | translate }}</span>
  <app-single-image-or-video-uploader
    [type]="type"
    [control]="form.controls.media"
    [form]="form"
    [fields]="fields"
    [brandId]="brandId"
  />
</form>
